import { useRouter } from '@application/utils';
import type { AnnouncementsGetAnnouncementsQuery } from '@gql/graphql';
import type { AnnouncementData } from '@presentation/pages';
import dayjs from 'dayjs';
import { useMemo } from 'react';

export const useFormatAnnouncements = (
  announcements?: AnnouncementsGetAnnouncementsQuery['findManyAnnouncement'] | null,
) => {
  const { language } = useRouter();

  const formattedAnnouncements: AnnouncementData[] | undefined = useMemo(() => {
    if (!announcements || !announcements.length) return;
    return announcements
      .filter((item) => !!item.translations.find((tr) => tr.language === language))
      .map((item) => {
        const translation =
          item.translations.find((tr) => tr.language === language) ?? item.translations[0];

        const date = dayjs(item.createdAt).format('DD MMMM YYYY').toString();
        return {
          id: item.id,
          title: translation?.title,
          content: translation?.content,
          date,
        } as AnnouncementData;
      });
  }, [announcements, language]);

  return { formattedAnnouncements };
};
